import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import { BonusFlags, isSingleTicket } from '../../../../../utils/bonus';
import ComposedBonusMessage from '../ComposedBonusMessage/ComposedBonusMessage';
import SeeDetailsLink from '../SeeDetailsLink/SeeDetailsLink';

import TicketsInfo from './components/TicketsInfo/TicketsInfo';

const TournamentTickets: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { balanceAmount, maxNumTickets, numOfTickets, bonusFlags, maxNumberOfDepositsLeft } =
    preCashinInfo as PreCashinInfo;

  const isSingleTicketInSet = isSingleTicket(preCashinInfo as PreCashinInfo);

  return (
    <>
      <ComposedBonusMessage
        amount={balanceAmount}
        bonus={Math.min(maxNumTickets, numOfTickets)}
        isFirst={false}
      />
      {/* eslint-disable-next-line no-bitwise */}
      {!!(bonusFlags & BonusFlags.GradualDepositAllowed) &&
        numOfTickets < maxNumTickets &&
        !!maxNumberOfDepositsLeft && <TicketsInfo isSingleTicket={isSingleTicketInSet} />}
      <SeeDetailsLink />
    </>
  );
};

export default TournamentTickets;
